import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

export type AccountNavItemId =
  | "general"
  | "document-settings"
  | "document-headers"
  | "sharing-options"
  | "ai-usage"
  | "ai-brain"
  | "skills"
  | "plan-billing"
  | "users";

type AccountPageState = {
  selectedItem: AccountNavItemId;
};

type AccountPageActions = {
  setSelectedItem: (id: AccountNavItemId) => void;
};

export const useAccountPageStore = create<
  AccountPageState & AccountPageActions
>((set) => ({
  selectedItem: "general",
  setSelectedItem: (id) => set({ selectedItem: id }),
}));

export const useAccountPageStoreShallow = <U>(
  selector: (store: AccountPageState & AccountPageActions) => U,
) => useAccountPageStore(useShallow(selector));
